import { useContext } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SmartDPHeader from "app/pages/SmartDP/SmartDPHeader/SmartDPHeader";
import MarketingBanner from "app/pages/Header/MarketingBanner/MarketingBanner";
import { useRouteMatch } from "react-router-dom";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { isWhiteLabel } from "app/reducers/brandSelector";
import {
	getAvailableCreditNotesTotal,
	getAvailableCreditsTotal,
	hasAnyCreditNotes,
} from "app/pages/Account/MyCoupons/couponSelector";
import { bindActionCreators } from "redux";
import { BRANDS } from "app/constants";
import { brandPropTypes } from "app/utils/propTypes";
import { getFilteredMarketingBanners } from "app/reducers/partnerSelector.js";

const SmartDPHeaderContainer = props => {
	const { marketingBanners = [] } = props;
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	const isSDPSearchPage = useRouteMatch({
		path: ["/sdp/search", "/"],
		exact: true,
		sensitive: true,
	});

	const isSDPListing = useRouteMatch({
		path: ["/sdp/listing"],
	});

	const hideBackButton = isSDPSearchPage || (props.brand === BRANDS.TO && isSDPListing);

	return (
		<>
			<MarketingBanner banners={marketingBanners} />
			<SmartDPHeader
				{...props}
				displayBackButton={!hideBackButton}
				isLogoSmall={!isSDPSearchPage && isMobile}
			/>
		</>
	);
};

SmartDPHeaderContainer.propTypes = {
	brand: brandPropTypes,
	marketingBanners: PropTypes.array,
};

const mapStateToProps = state => {
	const partner = state.partner;

	return {
		shouldDisplayCreditNotesEntry: hasAnyCreditNotes(state),
		isWhiteLabel: isWhiteLabel(state),
		userIsConnected: isAuthenticated(state),
		operatorEmail: state.auth.operatorEmail,
		enableCredits: partner.enableCredits,
		creditsAmount: getAvailableCreditsTotal(state),
		creditNotesAmount: getAvailableCreditNotesTotal(state),
		brand: state.brand.code,
		marketingBanners: getFilteredMarketingBanners(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SmartDPHeaderContainer);
